import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router';

import { ROUTES } from '@/constants/routes';
import { AuthContext } from '@/context/auth-context';
import { Loading } from '@/loading';
import { useOrgStore } from '@/stores/org-store';
import { isOrgAdmin } from '@/utils/org-role';
import { orgPath } from '@/utils/org-path';

/**
 * Org-admin pages (owner or admin role, or a platform super-admin), matching
 * platform-api's `require_org_admin`. Anyone else lands on the MCP server
 * catalog, which every org member may read.
 */
export const OrgAdminRoute = () => {
  const { user, loading } = useContext(AuthContext);
  const { currentOrg } = useOrgStore();

  if (loading) return <Loading />;

  if (user && !isOrgAdmin(user, currentOrg)) {
    return <Navigate to={orgPath(ROUTES.SETTINGS.MCP_SERVERS)} replace />;
  }

  return <Outlet />;
};
